import {I18n} from '@aws-amplify/core';
import {Field} from 'formik';

import {
    FormikNumberInput,
    FormikSelect,
    FormikTextInput,
    PlatformFieldset
} from '@flexinet/ui-components';
import {Stack} from "@mantine/core";
import {ComponentsDropdown as MetersDropdown} from "../../meters/inputs/MetersDropdown";
import {BillableUnitStatus} from "../types.ts";


export const FormComponent = () => {

    return (
        <Stack gap={'lg'}>
            <PlatformFieldset legend={I18n.get('Billable Unit')}>
                <Field
                    name='name'
                    label={I18n.get('Name')}
                    description={I18n.get('What the customer is charged in, e.g. "1000 Domains Managed"')}
                    component={FormikTextInput}
                    withAsterisk
                    my={'xl'}
                />

                <Field
                    name='description'
                    label={I18n.get('Description')}
                    description={I18n.get('Optional. What this unit represents.')}
                    component={FormikTextInput}
                    my={'xl'}
                />

                <Field
                    name='meterId'
                    label={I18n.get('Meter')}
                    description={I18n.get('The meter that supplies the measured quantity for this unit')}
                    component={MetersDropdown}
                    withAsterisk
                    my={'xl'}
                />

                <Field
                    name='meteredUnitsPerBillableUnit'
                    label={I18n.get('Metered units per billable unit')}
                    description={I18n.get('How many METERED units make ONE billable unit. 1000 means 1000 metered events are charged as one unit. Leave as 1 for a direct 1:1 unit.')}
                    component={FormikNumberInput}
                    min={1}
                    my={'xl'}
                />

                <Field
                    name='status'
                    label={I18n.get('Status')}
                    description={I18n.get('Draft units are not yet usable for pricing. The meter link is locked once a unit leaves Draft.')}
                    component={FormikSelect}
                    data={[{
                        value: BillableUnitStatus.DRAFT,
                        label: I18n.get('Draft')
                    }, {
                        value: BillableUnitStatus.ACTIVE,
                        label: I18n.get('Active')
                    }, {
                        value: BillableUnitStatus.RETIRED,
                        label: I18n.get('Retired')
                    }]}
                    my={'xl'}
                />
            </PlatformFieldset>
        </Stack>
    );
};
